import React, { useState } from "react";
import { Button, Card, Input, message, Typography, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useAPI } from "../lib/hook/APIProvider";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const { TextArea } = Input;
const { Title } = Typography;

const GetImpVehicleByInvs: React.FC = () => {
  const [invNosText, setInvNosText] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const { client } = useAPI();

  // 바로 엑셀 다운로드만 수행
  const handleDownloadExcel = async () => {
    const lines = invNosText
      .split(/\r?\n/)
      .map((x) => x.trim())
      .filter((x) => x.length > 0);

    if (lines.length === 0) {
      message.warning("송품장번호(Invoice No)를 한 개 이상 입력해주세요.");
      return;
    }

    setIsLoading(true);

    try {
      // 데이터 조회
      const res = await client.post("/preview/tcms/getImpVehicleByInvs", lines, { timeout: 0 });
      const resultData = Array.isArray(res.data) ? res.data : [];
      if (resultData.length === 0) {
        message.info("조회 결과가 없습니다.");
        return;
      }

      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet("ImpVehicleData");

      // Set columns by header row from resultData
      const headers = Object.keys(resultData[0] || {});
      ws.addRow(headers);

      resultData.forEach(row => {
        ws.addRow(headers.map(h => row[h]));
      });
      const buf = await wb.xlsx.writeBuffer();
      saveAs(new Blob([buf]), `ImpVehicleByInvs_${new Date().toISOString().slice(0, 10)}.xlsx`);
    } catch (err: any) {
      console.error(err);
      const msg = (err?.response?.data?.message) || err?.message || "오류가 발생했습니다.";
      message.error("실패: " + msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 py-12">
      <Card style={{ width: 600, marginBottom: 32 }}>
        <Title level={3}>송품장(Invoice) 번호로 수입 차량 엑셀 다운로드</Title>
        <div style={{ marginBottom: 16 }}>
          <span>송품장번호(Invoice No) 를 줄바꿈(엔터)으로 입력하세요.</span>
        </div>
        <TextArea
          value={invNosText}
          onChange={(e) => setInvNosText(e.target.value)}
          rows={6}
          placeholder={"예:\nINV20231001\nINV20231002"}
          disabled={isLoading}
        />
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <Button
            icon={<DownloadOutlined />}
            onClick={handleDownloadExcel}
            loading={isLoading}
            disabled={isLoading}
            type="primary"
            style={{ backgroundColor: "#1677ff", borderColor: "#1677ff" }}
          >
            엑셀 다운로드
          </Button>
        </div>
      </Card>
      <div style={{ width: "100%", maxWidth: 1200 }}>
        <Spin spinning={isLoading}></Spin>
      </div>
    </div>
  );
};

export default GetImpVehicleByInvs;
